import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/img/change/role1.jpg';
import _imports_1 from '../assets/img/change/role2.jpg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-48b74671"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};
var _hoisted_2 = {
  class: "shadow"
};
var _hoisted_3 = {
  class: "err"
};
var _hoisted_4 = {
  class: "contentone"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "后台管理", -1);
});

var _hoisted_7 = [_hoisted_5, _hoisted_6];

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "个人中心", -1);
});

var _hoisted_10 = [_hoisted_8, _hoisted_9];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h3", {
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.toindex && _ctx.toindex.apply(_ctx, arguments);
    })
  }, "×")]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "er one",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.gosw(1);
    })
  }, _hoisted_7), _createElementVNode("div", {
    class: "er two",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.gosw(0);
    })
  }, _hoisted_10)])])]);
}